(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6660,1674],{

/***/ 530131:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/orders",
      function () {
        return __webpack_require__(868441);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 868441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125291);
/* harmony import */ var _containers_Orders__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(219209);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(268037);
/**
 * Orders Page
 */ 




var OrdersPage = function(props) {
    var ref, ref1;
    (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSetSSRStore */ .Vn)(props.ssrStore);
    var storeData = (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        store: storeData,
        title: "Orders - Now Shop Online",
        Icon: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.logo_image,
        metaDescription: "Now order online from my whatsapp store & pay using 150+ UPI Apps",
        OGImage: storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.logo_image,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Orders__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (OrdersPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8388,1562,7779,1033,5291,3978,8557,719,9209,9774,2888,179], function() { return __webpack_exec__(530131); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);